import BallIcon from "src/assets/images/ball.svg";
import styled from "src/settings/theme/styled";
import { useFloatAnimation } from "./use-float-animation";
import React from "react";

const Ball = () => {
  const {
    initialPosition,
    floatKeyframes,
    durationInSeconds,
  } = useFloatAnimation();

  const AnimatedImage = styled.img`
    position: absolute;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-name: ${floatKeyframes};
    animation-duration: ${durationInSeconds}s;
    top: ${initialPosition.top}px;
    bottom: ${initialPosition.bottom}px;
    left: ${initialPosition.left}px;
    right: ${initialPosition.right}px;
  `;

  return <AnimatedImage src={BallIcon} alt="ball" />;
};

export default Ball;
